import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { store } from "./Redux/store";
import {
  APP_SMARTVERIFY,
  S_CURRENT_MEMBER_ID,
} from "./Communication/Constants";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./index.scss";
import "./Styles/globalStyles.scss";
import "./Styles/custom.scss";

//TODO uncomment for smart verify branch
//  import "./Styles/smartVerify.scss";

import "./Styles/smartBranch.scss";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
